import { createContext } from 'react';
export const DeviceLinkContext = createContext({
    device: undefined,
    prelinkedDevice: [],
    unlinkDevice: undefined,
    location: undefined,
    updateLocation: true,
    allowEntities: true,
    entityOptions: [],
    selectedEntityType: undefined,
    choosenEntity: undefined,
    entityList: [],
    deviceGroups: [],
    selectedGroup: undefined,
    areaList: [],
    relevantAreas: [],
});
